// extracted by mini-css-extract-plugin
export var content = "styles-module--content--1QtKi";
export var link = "styles-module--link--7J4N3";
export var highlight = "styles-module--highlight--dKS45";